import { Select } from "antd";
import { useEffect, useState } from "react";

const SingleSelect = ({ options, handleRulesOnValueChange, placeholder, value }: any) => {
  const [fieldValue, setFieldValue] = useState(value);

  const onChange = (value: any) => {
    setFieldValue(value);
    handleRulesOnValueChange(value);
  };

  useEffect(() => {
    setFieldValue(value);
  }, [value]);

  return (
    <Select size="large" placeholder={placeholder} value={fieldValue} style={{ width: "100%" }} onChange={(value) => onChange(value)}>
      {options.map((opt: any) => {
        return <Select.Option key={opt.id}>{opt.value}</Select.Option>;
      })}
    </Select>
  );
};

export default SingleSelect;
